import { render } from "./Software.vue?vue&type=template&id=4ca9f003&scoped=true"
const script = {}

import "./Software.vue?vue&type=style&index=0&id=4ca9f003&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\ATL\\Desktop\\Dev\\p2-osavus\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca9f003"]])

export default __exports__